import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4 py-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Voltar"), -1)
const _hoisted_3 = { class: "flex flex-col md:flex-row justify-between mx-8 gap-8 text-h-primary-500" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row gap-2 sm:items-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Nota:"), -1)
const _hoisted_7 = { class: "bg-h-primary-100 p-2 rounded-md" }
const _hoisted_8 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Status:"), -1)
const _hoisted_10 = { class: "p-4 rounded-md border border-b-4 border-b-h-primary-500 flex flex-col gap-4 mx-8" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "flex flex-wrap gap-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex flex-row items-center gap-2" }
const _hoisted_16 = {
  key: 0,
  class: "flex flex-row-reverse mx-8"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", { class: "mx-8 my-2 text-h-primary-500" }, /*#__PURE__*/_toDisplayString("Envio"), -1)
const _hoisted_19 = { class: "border border-b-h-primary-500 border-b-4 rounded-md p-4 mx-8 flex flex-col gap-4" }
const _hoisted_20 = { class: "pb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Comentário: "), -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Anexo enviado:"), -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex flex-row justify-between items-center p-4 rounded-sm bg-h-primary-50 w-[240px] cursor-pointer" }
const _hoisted_26 = { class: "flex flex-row items-center gap-2" }
const _hoisted_27 = {
  key: 0,
  class: "py-6"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h5", { class: "mx-8 my-2 text-h-primary-500" }, /*#__PURE__*/_toDisplayString("Feedbacks"), -1)
const _hoisted_29 = { class: "border border-b-h-primary-500 border-b-4 rounded-md py-6 p-4 mx-8 flex flex-col gap-4 h-20" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Comentário do Professor:"), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormStudentActivity = _resolveComponent("FormStudentActivity")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, {
      loader: _ctx.loading.activity
    }, null, 8, ["loader"]),
    (!_ctx.loading.activity)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _createVNode(_component_Button, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goBack()), ["prevent"])),
            class: "btn-simple flex flex-row gap-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { name: "md-arrowbackiosnew-round" }),
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.activity?.activity?.title), 1),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.activity?.feedback)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(`${_ctx.activity?.score} / ${_ctx.activity?.activity?.scoreRange}`), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.activity?.status?.class)
                }, [
                  _createVNode(_component_v_icon, {
                    name: _ctx.activity?.status?.icon
                  }, null, 8, ["name"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.activity?.status?.text), 1)
                ], 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Data de Início:", en: "Inital Date" })), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.initialDate(_ctx.activity.activity?.startDate)), 1)
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Prazo de entrega:", en: "Deadline" })), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.finalDate(_ctx.activity.activity?.finalDate)), 1)
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Pontuação:", en: "Score:" })), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.scoreRange), 1)
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Descrição:", en: "Description:" })), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.activity?.activity?.description,
                class: "ql-editor"
              }, null, 8, _hoisted_11)
            ]),
            (_ctx.activity?.activity?.materials?.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Arquivo de apoio enviado:",
            en: "Supporting file sent:",
          })), 1),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity?.activity?.materials, (material, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex gap-4 py-3"
                      }, [
                        _createElementVNode("div", {
                          class: "!bg-h-primary-50 rounded-sm text-h-primary-700 w-[240px] flex flex-row items-center justify-between p-4 cursor-pointer",
                          onClick: _withModifiers(($event: any) => (_ctx.downloadMaterial(material?.id)), ["prevent"])
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_v_icon, { name: "hi-solid-document-text" }),
                            _createElementVNode("p", null, _toDisplayString(`${material?.name}.${material?.mimetype}`), 1)
                          ]),
                          _createVNode(_component_v_icon, { name: "hi-solid-download" })
                        ], 8, _hoisted_14)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isNotExpired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _createVNode(_component_Button, {
                  label: 
          _ctx.$t('labels.generic', { en: 'Send Activity', pt: 'Enviar Atividade' })
        ,
                  icon: "pi pi-file-plus",
                  class: "btn-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialogForm()))
                }, null, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.activity?.status?.value === _ctx.activityStatus.ASSIGNED ||_ctx.activity?.status?.value === _ctx.activityStatus.FEEDBACK) && (_ctx.activity?.textAnswer || _ctx.activity?.mediaAnswer?.length > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h5", _hoisted_20, _toDisplayString("Atividade Enviada - " + _ctx.activity?.activity?.title), 1),
                  _createElementVNode("p", null, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.activity?.textAnswer?? "Nenhum comentário"), 1)
                  ]),
                  (_ctx.activity?.mediaAnswer?.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                        _hoisted_23,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity?.mediaAnswer, (media, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "py-3",
                            onClick: _withModifiers(($event: any) => (_ctx.downloadMaterial(media?.id)), ["prevent"])
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_v_icon, { name: "io-document-text-sharp" }),
                                _createElementVNode("p", null, _toDisplayString(media.name +"."+media.mimetype), 1)
                              ]),
                              _createVNode(_component_v_icon, { name: "hi-solid-download" })
                            ])
                          ], 8, _hoisted_24))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.activity?.status?.value === _ctx.activityStatus.FEEDBACK)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("p", null, [
                          _hoisted_30,
                          _createTextVNode(" " + _toDisplayString(_ctx.activity?.feedback?? "Nenhum comentário adicionado"), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Dialog, {
            visible: _ctx.showDialog,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDialog) = $event)),
            breakpoints: { '960px': '75vw', '640px': '90vw' },
            style: { width: '45vw' },
            modal: true,
            draggable: false,
            header: 'Enviar atividade'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormStudentActivity, {
                activityId: _ctx.activityId,
                visible: _ctx.showDialog,
                "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDialog) = $event)),
                onActivitySent: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getActivity()))
              }, null, 8, ["activityId", "visible"])
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}